import { useTracking } from 'react-tracking';
import { Row } from '@simplywallst/ui-core';
import { AuthorPhoto, AuthorWrapper, Byline } from './styled';

type Props = {
  authorSlug: string;
  author: string;
  authorAvatarUrl: string;
  index: number;
  publishedDate: string;
};

export const Author = ({
  author,
  authorSlug,
  authorAvatarUrl,
  index,
  publishedDate,
}: Props) => {
  const { trackEvent } = useTracking();
  return (
    <Row>
      <AuthorWrapper>
        <Byline>
          <AuthorPhoto>
            <img
              src={authorAvatarUrl}
              alt={`${author} avatar`}
              data-cy-id={`article-card-author-avatar-${index}`}
            />
          </AuthorPhoto>
          <a
            href={`https://simplywall.st/news/about-simply-wall-st-news/${authorSlug}`}
            data-cy-id={`article-card-author-link-${index}`}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              trackEvent({
                type: 'track',
                action: 'click',
                subject: 'authorNameBelowArticle',
              });
            }}
          >
            <span>{author}</span>
          </a>
          <time
            dateTime={publishedDate}
            data-cy-id={`article-card-time-${index}`}
          >
            {publishedDate}
          </time>
        </Byline>
      </AuthorWrapper>
    </Row>
  );
};
